// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GyIpn table{width:100%;table-layout:fixed}.GyIpn .Si1Qf{width:auto}.GyIpn .gtm6Z{width:1%;white-space:nowrap}.GyIpn .n9Kab{width:1%}.GyIpn th{border-bottom:none;padding:8px 12px;color:#9393b1;background:#f4f4f7}.GyIpn th:first-of-type{border-top-left-radius:8px;border-bottom-left-radius:8px}.GyIpn th:last-of-type{border-top-right-radius:8px;border-bottom-right-radius:8px}.GyIpn .GhCsX{padding-left:24px}.GyIpn .wmF45.SjkGN>td{border-bottom:none;padding-bottom:0}.GyIpn .wmF45:hover>td,.GyIpn .wmF45:focus-within>td{background-color:#f4f4f7}.GyIpn .wmF45:hover .MuiOutlinedInput-root:not(.Mui-disabled),.GyIpn .wmF45:focus-within .MuiOutlinedInput-root:not(.Mui-disabled){background-color:#fff}.GyIpn .wmF45.SjkGN:hover+.I0GwK>td,.GyIpn .wmF45.SjkGN:focus-within+.I0GwK>td,.GyIpn .wmF45.SjkGN:has(+.I0GwK:hover)>td{background-color:#f4f4f7}.GyIpn .I0GwK:hover>td{background-color:#f4f4f7}.GyIpn td{border-bottom:1px solid #e4e4ec;padding:12px 8px;vertical-align:middle}.GyIpn .Fg4ME{padding-top:8px}.GyIpn .gxNsj{border-bottom:none;padding:8px 0}.GyIpn .vmDhU{height:8px;padding:0;border-bottom:none}.GyIpn .Iabn2>td{border-bottom:none}.GyIpn .x7RMD{width:48px;padding-left:16px;padding-right:8px;white-space:nowrap}.GyIpn .MuiTableCell-alignRight>*{justify-content:flex-end}.GyIpn .Fi_mn>td{padding-top:12px}.oQr7J{padding-bottom:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"radius0": `0px`,
	"radius2": `2px`,
	"radius4": `4px`,
	"radius8": `8px`,
	"radius12": `12px`,
	"radius16": `16px`,
	"radius20": `20px`,
	"radius24": `24px`,
	"spacing0": `0px`,
	"spacing2": `2px`,
	"spacing4": `4px`,
	"spacing8": `8px`,
	"spacing12": `12px`,
	"spacing16": `16px`,
	"spacing20": `20px`,
	"spacing24": `24px`,
	"spacing32": `32px`,
	"spacing40": `40px`,
	"tableContainer": `GyIpn`,
	"growColumn": `Si1Qf`,
	"shrinkColumn": `gtm6Z`,
	"cappedColumn": `n9Kab`,
	"inputAlignedHeader": `GhCsX`,
	"tableRow": `wmF45`,
	"hasFooter": `SjkGN`,
	"rowFooterRow": `I0GwK`,
	"footerCell": `Fg4ME`,
	"belowEditableCell": `gxNsj`,
	"headerSpacer": `vmDhU`,
	"lastBeforeSlot": `Iabn2`,
	"removeCell": `x7RMD`,
	"totalSummaryRow": `Fi_mn`,
	"editSheetContent": `oQr7J`
};
export default ___CSS_LOADER_EXPORT___;
